import TableHeader from "./TableHeader";
import TableBody from "./TableBodyComp";
import { ReactNode } from "react";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

export type IconType = OverridableComponent<SvgIconTypeMap<object, "svg">> & {
  muiName: string;
};

export interface StringObj {
  [x: string]: string;
}

export interface SortQueryType {
  key: string;
  dir: string;
}

export interface ItemType {
  error: boolean;
  id: number;
  type?: string;
}

export interface TitleType {
  key: string;
  name: string;
  Component: any;
  price: number;
  navigate: string;
}

export interface ActionObj {
  [x: string]: any;
}

export interface TableIndexProps {
  tableItemsLength: number;
  page: number;
  limit: number;
  selectedItemsLength: number;
  selectedItems: (number | string)[];
  titles: any[];
  items: ItemType[];
  sortQuery: SortQueryType;
  loading: boolean;
  secretView: boolean;
  setSortQuery: (items: any) => void;
  searchItems: (sort?: any, search?: any) => void;
  searchQuery: any;
  setSearchQuery: (items: any) => void;
  selectItem: (id: number | string) => void;
  selectAllItems: () => void;
  displayValue: (item: ItemType, title: TitleType, items: ItemType[]) => ReactNode;
  copyText: (id: string | number) => void;
  deleteItem: (id: string | number, item?: any) => void;
  actions: ActionObj;
  activeTab: StringObj;
  allTitles: any[];
  notSelectable?: boolean;
  sumAmountInfo?: { name: string, isCurrency?: boolean }[]
}

export const isSelectable = (actions: ActionObj, notSelectable?: boolean) => {
  if (!actions || actions?.notSelectable) {
    return false;
  } else if (actions["delete"] || actions["openDrawer"] || actions["view"] || actions["custome"]) {
    return true;
  }
  return false;
};
export const showMenu = (actions: ActionObj, notSelectable?: boolean) => {
  if (!actions) {
    return false;
  } else if (actions["delete"] || actions["printFishSalary"] || actions["reSendForTax"] || actions["openDrawer"] || actions["editMoaddian"] || actions["view"] || actions["sendForTax"] || actions["inquiry"] || actions["cancelled"]) {
    return true;
  }
  return false;
};

export default function TableIndex(props: TableIndexProps) {
  return (
    <table className="data-table">
      <TableHeader {...props} />
      <TableBody {...props} />
    </table>
  );
}
